import { useQuery } from '@apollo/client';

import query from './query.graphql';
import TableRow from './TableRow';

function THead({ children }) {
  return (
    <th
      scope="col"
      className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
      {children}
    </th>
  );
}

export default function AccountPlan() {
  const { data, loading } = useQuery(query);

  if (loading) {
    return <div>Loading</div>;
  }

  return (
    <div className="flex flex-col">
      <div className="h-full -my-2 overflow-x-auto overflow-y-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="border-b border-gray-200 shadow sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <THead>Flag Setting</THead>
                  <THead>Setting</THead>
                  <THead>Is Overridden?</THead>
                  <th scope="col" className="relative px-6 py-3" colSpan={3}>
                    <span className="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {data.availableFeatureFlags.map((flag) => (
                  <TableRow key={flag} flag={flag} />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
